/**
 * Provides the dataLayer array for event pushes.
 * Loader is injected via MtgsNs (Stape Custom Loader), not @nuxt/scripts.
 */
export function useGtmDataLayer() {
  if (import.meta.server) {
    return { dataLayer: [] }
  }

  window.dataLayer = window.dataLayer || []

  return {
    dataLayer: window.dataLayer,
  }
}
